import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { TableRow } from "./TableRow";
import { defaultTableHeaderStyle } from "./dataset";

export type TableProps = ComponentProps<"table"> & {
  data: React.ReactNode[][];
  tableHeaderStyles?: React.CSSProperties[];
  tableCellStyles?: React.CSSProperties[];
  onRowClick?: (index: number) => void;
};

export const Table = ({
  data,
  tableHeaderStyles: thStyles = [],
  tableCellStyles: tdStyles = [],
  onRowClick,
  ...props
}: TableProps) => {
  const [headers, ...rows] = data;

  return (
    <table
      {...props}
      className={twMerge(
        "w-full divide-y divide-gray-300 text-sm",
        props.className
      )}
    >
      <thead>
        {
          <tr>
            {headers?.map((header, i) => (
              <th
                key={i}
                scope="col"
                className="px-4 py-3.5 font-medium text-gray-900"
                style={{ ...defaultTableHeaderStyle, ...thStyles[i] }}
              >
                {header}
              </th>
            ))}
          </tr>
        }
      </thead>
      <tbody className="divide-y divide-gray-200">
        {rows?.map((row, i) => (
          <TableRow
            key={i}
            rowIndex={i}
            rowData={row}
            onRowClick={onRowClick}
            tdStyles={tdStyles}
          />
        ))}
      </tbody>
    </table>
  );
};
